import router from '@/router'
import store from '../store'
export default {
  //当不传path参数时，path为当前路由值
  //是否有读权限
  canRead(path = null) {
    return this.can("浏览", path);
  },
  //是否有写权限
  canWrite(path = null) {
    return this.can("添加", path);
  },
  canEdit(path = null) {
    return this.can("修改", path);
  },
  canDel(path = null) {
    return this.can("删除", path);
  },
  canReview(path = null) {
    return this.can("审核", path);
  },
  canImport(path = null) {
    return this.can("导入", path);
  },
  canExport(path = null) {
    return this.can("导出", path);
  },
  canSale(path = null) {
    return this.can("上下架", path);
  },
  canNew(path = null) {
    return this.can("新品", path);
  },
  canHot(path = null) {
    return this.can("热销", path);
  },
  canRecommend(path = null) {
    return this.can("爆款", path);
  },
  canCategory(path = null) {
    return this.can("分类", path);
  },
  //是否有审核权限
  // canReview(path = null) {
  //   let res1 = this.can("一级审核", path);
  //   let res2 = this.can("二级审核", path);

  //   if (res1 == true && res2 == true) {
  //     return 3; //有一级审核与二级审核
  //   } else if (res1 == true && res2 == false) {
  //     return 1; //只有 一级审核
  //   } else if (res1 == false && res2 == true) {
  //     return 2; //只有二级审核
  //   } else if (res1 == false && res2 == false) {
  //     return 0; //没有审核权限
  //   } else {
  //     return 0;
  //   }
  // },
  can(action, path = null) {
    if (!path) {
      path = router.history.current.path;
    }
    // console.log(path);
    // console.log('can', JSON.parse(JSON.stringify(store.state.sys.permissionMenus)))
    return store.state.sys.permissionMenus.some(item => {
      if (item.FullPath == path || item.PermissionPath == path) {
        // console.log(item.FuncNames)
        // console.log(item.FuncNames.indexOf(action) != -1)
        return item.FuncNames.indexOf(action) != -1 || false;
      }
    })
  },
  //是否有某个菜单
  hasMenu(path) {
    return store.state.sys.permissionMenus.some(item => item.fullPath == path || item.permissionPath == path);
  },
  isStore(){
    var userinfo=JSON.parse(localStorage.getItem("loginInfo"))
    return userinfo.UserType==1;
  }
}